export enum BalanceDueNumber {
  ZERO = 0,
  TWO_FIFTY = 250,
}
